export var ERouteControlViewType = /*#__PURE__*/function (ERouteControlViewType) {
  ERouteControlViewType["default"] = "default";
  ERouteControlViewType["stickyLeft"] = "stickyLeft";
  ERouteControlViewType["stickyBottom"] = "stickyBottom";
  return ERouteControlViewType;
}({});